<template>
  <div class="products-sub-root" :style="panelStyle">
    <div class="products-sub-glass" :class="{ 'is-visible': cascadeMenuOpen }" />
    <scrollbar ref="scrollbar" class="products-sub-wrap p-3" @scroll="handleScroll">
    <!-- 滚动标记点 -->
    <div id="scroll-start" class="none" />
    <div :class="`products-header pt-3 pl-3 pr-3 ${scrollY > 0 ? 'shadow-sm' : ''}`" id="products-header" :style="headerStyle">
      <!-- 搜索 -->
      <div class="products-title-wrap">
        <div class="search-wrap">
          <icon class="search-icon" type="search" />
          <a-input class="search" type="search" v-model="search" allowClear :placeholder="$t('common.function_search')" />
        </div>
        <div class="close mt-1"><a-icon type="close" @click="close" /></div>
      </div>
      <div v-if="nearModule.menus.length" class="none mb-2" style="margin-top:20px" />
      <!-- 最近访问 -->
      <div v-if="nearModule.menus.length" class="recent-module d-flex">
        <div class="recent-title">{{ nearModule.title }}</div>
        <div class="recent-list d-flex">
          <div v-for="item in nearModule.menus" :key="item.path" class="recent-item d-flex align-items-center" :class="{ 'stared': item.stared }" @click="hanldeRouterChange(item)">
            <div class="link">{{ item.title }}</div>
            <div class="icon" @click="(e) => handleStar(e, item)">
              <icon :type="item.stared ? 'stared' : 'star'" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="none mb-2" :style="contentTopStyle" />
    <!-- 查找结果 -->
    <div v-if="search" class="result-wrap mb-4">
      <span class="search-text">{{ search }}</span>:
      {{ searchValueCount ? $t('common.search_result_num', [searchValueCount]) : $t('common.search_result_none') }}
    </div>
    <!-- 模块 -->
    <div class="module-wrap">
      <div v-for="(m, index) in moduleList.list" :key="index" :id="index === moduleList.list.length - 1 ? 'last-module' : ''">
        <template v-if="m.index !== 1">
          <template v-for="(group, groupIdx) in m.groups">
            <div v-if="true" :key="`${index}-${groupIdx}`" :id="groupIdx === 0 ? `resource-${m.index}` : ''">
              <div v-if="m.index !== 1" class="d-flex align-items-center mb-3">
                <div class="module-title">{{ m.title }}</div>
                <div class="line" />
              </div>
              <div
                v-for="(moduleGroupItem, indexxx) in group.menusL2"
                :key="`${index}-${indexxx}`"
                :id="`resource-${m.index}-subgroup-${moduleGroupItem.subGroup}`"
                class="module-list pb-3 ">
                <div class="d-flex align-items-center" v-if="group.menusL2.length > 1">
                  <div class="module-title">{{ $t(`scope.products_group.${moduleGroupItem.subGroup}`) }}</div>
                </div>
                <div class="module-list-card" style="padding-top:10px;padding-left: 5px">
                  <div v-for="(moduleItem, index2) in moduleGroupItem.menus" :key="`${index}-${indexxx}-${index2}`" class="module-item d-flex">
                    <div class="module-item-title">{{ moduleItem.title }}</div>
                    <div class="module-item-link-wrapper d-flex">
                      <div v-for="(item, index3) in moduleItem.submenus" :key="`${index}-${indexxx}-${index2}-${index3}`" class="module-item-link d-flex align-items-center" :class="{ 'stared': item.stared }" @click="hanldeRouterChange(item)">
                        <div class="link" :title="item.title">{{ item.title }}</div>
                        <div class="icon" @click="(e) => handleStar(e, item)">
                          <icon :type="item.stared ? 'stared' : 'star'" :title="item.stared ? $t('common.remove_store') : $t('common.store_to_my_menus')" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
    <div :style="paddingStyle" />
    </scrollbar>
  </div>
</template>

<script>
import * as R from 'ramda'
import { mapGetters, mapState } from 'vuex'
import PinYinMatch from 'pinyin-match'
import { MENU_TAGS } from '@generalScope/constants/featureMenus'
import { hasPermission } from '@/utils/auth'

export default {
  name: 'ProductsSubList',
  props: {
    activeMenu: Object,
    menus: Array,
    cascadeMenuOpen: Boolean,
    panelStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      search: '',
      paddingHeight: 0,
      scrollX: 0,
      scrollY: 0,
      lastExplicitScrollAt: 0,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    ...mapState('common', {
      staredList: state => state.sidebar.staredList,
      recentList: state => state.sidebar.recentList,
    }),
    nearModule () {
      const ret = {
        title: this.$t('common.recent_visit'),
        menus: this.moduleList.menus.filter(item => this.recentList.includes(item.path)),
      }
      ret.menus.sort((a, b) => {
        const aIdx = this.recentList.indexOf(a.path)
        const bIdx = this.recentList.indexOf(b.path)
        return aIdx - bIdx
      })
      return ret
    },
    contentTopStyle () {
      if (!this.nearModule.menus.length) {
        return { marginTop: '60px' }
      } else if (this.nearModule.menus.length < 4) {
        return { marginTop: '105px' }
      } else {
        return { marginTop: '145px' }
      }
    },
    headerStyle () {
      if (!this.nearModule.menus.length) {
        return { height: '65px' }
      } else if (this.nearModule.menus.length < 4) {
        return { height: '115px' }
      } else {
        return { height: '150px' }
      }
    },
    moduleList () {
      const ls = this.menus
      const list = []
      const menus = []
      const lss = []
      const lsa = []
      ls.map(item => {
        const lsItem = {
          title: this.getLabel(item.meta),
          menus: [],
          groups: [],
          groupNames: [],
          index: item.index,
        }
        if (item.menus) {
          item.menus.map(menu => {
            const menuItem = {
              title: this.getLabel(menu.meta),
              submenus: [],
              group: menu.group,
              subGroup: menu.subGroup,
            }
            if (menu.submenus) {
              const menuTitleMatched = this.isSearchTextMatch(menuItem.title)
              const groupMatched = this.isSearchTextMatch(
                this.getProductsGroupLabel(menu.group),
              )
              const subGroupMatched = this.isSearchTextMatch(
                this.getProductsGroupLabel(menu.subGroup),
              )
              const groupSearchMatched = menuTitleMatched || groupMatched || subGroupMatched
              menu.submenus.map(submenu => {
                const l = {
                  title: this.getLabel(submenu.meta),
                  path: submenu.path,
                  stared: this.staredList.includes(submenu.path),
                }
                if (!lss.includes(l.path)) {
                  lss.push(l.path)
                } else {
                  console.log('当前资源路径冲突', l.path, l.title)
                }
                if (!lsa.includes(l.title)) {
                  lsa.push(l.title)
                } else {
                  // console.log('当前资源名称冲突', l.title, l.path)
                }
                const submenuMatched = this.isSubmenuSearchMatch(l)
                const searchMatched = !this.search || groupSearchMatched || submenuMatched
                const isHidden = submenu.meta?.hidden
                  ? (R.is(Function, submenu.meta.hidden)
                    ? submenu.meta.hidden(this.userInfo, submenu)
                    : submenu.meta.hidden)
                  : false
                const isPermission = submenu.meta?.permission ? hasPermission({ key: submenu.meta.permission }) : true
                if (searchMatched && !isHidden && isPermission) {
                  menuItem.submenus.push(l)
                  menus.push(l)
                }
              })
            }
            if (menuItem.submenus.length > 0) {
              lsItem.menus.push(menuItem)
              const groupIndex = lsItem.groups.findIndex(item => item.group === menuItem.group)
              if (groupIndex > -1) {
                lsItem.groups[groupIndex].menus.push(menuItem)
              } else {
                lsItem.groups.push({
                  group: menuItem.group,
                  menus: [menuItem],
                })
                lsItem.groupNames.push(menuItem.group)
              }
            }
          })
        }
        if (lsItem.menus.length > 0) {
          list.push(lsItem)
        }
      })
      // 再次分组
      list.map(item => {
        item.groups.map(group => {
          const list = []
          group.menusL2 = []
          group.menus.forEach(menu => {
            if (!list.includes(menu.subGroup)) {
              list.push(menu.subGroup)
            }
          })
          list.forEach(subGroup => {
            const list = group.menus.filter(menu => menu.subGroup === subGroup)
            group.menusL2.push({
              subGroup,
              menus: list,
            })
          })
        })
      })
      return { list, menus }
    },
    searchValueCount () {
      let count = 0
      this.moduleList.list.map(item => {
        item.menus.map(menuItem => {
          count += menuItem.submenus.length
        })
      })
      return count
    },
    paddingStyle () {
      if (this.nearModule.menus.length > 3) {
        return `height: ${this.paddingHeight - 60}px`
      } else if (this.nearModule.menus.length > 0) {
        return `height: ${this.paddingHeight - 35}px`
      }
      return `height: ${this.paddingHeight}px`
    },
  },
  watch: {
    'moduleList.list': {
      handler () {
        this.refreshPadding()
      },
      deep: true,
    },
    search () {
      this.refreshPadding()
    },
    activeMenu (val) {
      if (!val || val.index === 1) return
      this.$nextTick(() => {
        setTimeout(() => {
          if (Date.now() - this.lastExplicitScrollAt < 80) return
          this.scrollToSection({ moduleIndex: val.index })
        }, 50)
      })
    },
  },
  created () {
    this.$bus.$on('ProductsSubDrawerClose', () => {
      this.search = ''
    })
  },
  mounted () {
    window.addEventListener('resize', this.initPaddingHeight)
    this.initPaddingHeight()
    this.initScrollPosition()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.initPaddingHeight)
  },
  methods: {
    initScrollPosition () {
      if (this.$refs.scrollbar) {
        this.scrollX = this.$refs.scrollbar.moveX
        this.scrollY = this.$refs.scrollbar.moveY
      }
    },
    scrollToSection ({ moduleIndex, subGroup }) {
      this.lastExplicitScrollAt = Date.now()
      const start = document.getElementById('scroll-start')
      const id = subGroup
        ? `resource-${moduleIndex}-subgroup-${subGroup}`
        : `resource-${moduleIndex}`
      const dom = document.getElementById(id)
      if (dom && start && this.$refs.scrollbar) {
        this.$refs.scrollbar.changeMoveY(dom.getBoundingClientRect().y - start.getBoundingClientRect().y)
      }
      this.refreshPadding()
    },
    refreshPadding () {
      this.$nextTick(() => {
        this.initPaddingHeight()
        this.$nextTick(() => {
          this.initPaddingHeight()
        })
      })
    },
    handleScroll (moveY, moveX) {
      this.scrollX = moveX
      this.scrollY = moveY
    },
    getGroupName (group) {
      return group ? ` - ${this.getProductsGroupLabel(group)}` : ''
    },
    getProductsGroupLabel (group) {
      if (!group) return ''
      const key = `scope.products_group.${group}`
      return this.$te(key) ? this.$t(key) : group
    },
    isSearchTextMatch (text) {
      if (!this.search) return false
      if (!text) return false
      return !!PinYinMatch.match(String(text).toLowerCase(), this.search.toLowerCase())
    },
    getMenuPathKey (path) {
      if (!path) return ''
      return String(path).replace(/^\//, '')
    },
    isPathTagsMatch (path) {
      const tags = MENU_TAGS[this.getMenuPathKey(path)]
      if (!Array.isArray(tags) || !tags.length) return false
      return tags.some(tag => this.isSearchTextMatch(tag))
    },
    isSubmenuSearchMatch (submenu) {
      if (!submenu) return false
      return this.isSearchTextMatch(submenu.title) ||
        this.isSearchTextMatch(submenu.path) ||
        this.isPathTagsMatch(submenu.path)
    },
    getLabel (meta) {
      if (meta.t) {
        return this.$t(meta.t)
      }
      return R.is(Function, meta.label) ? meta.label() : meta.label
    },
    close () {
      this.$emit('close')
    },
    hanldeRouterChange (menu) {
      this.$emit('routerChange', menu)
      this.$emit('close')
    },
    handleStar (e, menu) {
      e.stopPropagation()
      let list = this.staredList
      if (list.includes(menu.path)) {
        list = list.filter(item => item !== menu.path)
      } else {
        list.unshift(menu.path)
      }
      this.$emit('updateStaredMenu', list)
    },
    initPaddingHeight () {
      const start = document.getElementById('products-header')
      if (!start) return
      const rect = start.getBoundingClientRect()
      const allHeight = window.innerHeight - 122 - rect.top
      const last = document.getElementById('last-module')
      if (last) {
        const lastRect = last.getBoundingClientRect()
        this.paddingHeight = allHeight - lastRect.height > 0 ? allHeight - lastRect.height : 0
      }
    },
  },
}
</script>

<style lang="less" scoped>
.products-sub-root {
  flex: 1;
  position: relative;
  min-width: 0;
  height: 100%;
  box-sizing: border-box;
}

.products-sub-glass {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0.25);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;

  &.is-visible {
    opacity: 1;
    visibility: visible;
  }
}

.products-sub-wrap {
  height: 100%;
  position: relative;

  .products-header {
    position: absolute;
    width: 100%;
    background: #fff;
    height: 70px;
    left: 0;
    top: 0;
    padding-bottom: 15px;
    .products-title-wrap {
      display: flex;
      width: 100%;
      .search-wrap {
        width: 100%;
        flex: 1;
        position: relative;
        border-bottom: 1px solid #ebebeb;
        .search-icon {
          position: absolute;
          left: 5px;
          top: 9px;
        }
        .search {
          width: 100;
          padding-left: 20px;
        }
        &::v-deep input {
          border: none !important;
          font-size: 14px !important;
          color: #606266 !important;
          outline: none !important;
        }
        &::v-deep input:focus {
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
        }
      }
      .close {
        flex: 0 0 20px;
        font-size: 18px;
        font-weight: 200;
        margin-left: 10px;
      }
    }
  }

  // 最近访问
  .recent-module {
    background: #fff;
    font-size: 14px;
    .recent-title {
      padding: 8px;
      color: black;
      font-weight: bold;
      flex: 0 0 20%;
    }
    .recent-list {
      flex-wrap: wrap;
      flex: 0 0 80%;
      .recent-item {
        flex: 0 0 33.33%;
        width: 33.33%;
      }
    }
  }

  .result-wrap {
    font-size: 14px;
    .search-text {
      display: inline-block;
      padding: 3px 5px;
      color: var(--antd-wave-shadow-color);
      background: #ebebeb;
      border-radius: 3px;
    }
  }

  .module-wrap {
    margin-top: 10px;
    margin-bottom: 15px;
    .module-title {
      font-size: 14px;
      font-weight: bold;
      margin-right: 10px;
      color: black;
    }
    .line {
      border-top: 1px solid #ebebeb;
      flex: 1;
    }
    .module-list {
      font-size: 14px;
      // columns: auto 3;
      .module-item {
        // break-inside: avoid;
        flex-wrap: wrap;
        .module-item-title {
          width: 20%;
          flex: 0 0 20%;
          padding: 8px;
          color: black;
          font-weight: bold;
        }
        .module-item-link-wrapper {
          flex: 0 0 80%;
          flex-wrap: wrap;
        }
      }
    }
  }
}
.products-sub-wrap {
  ::v-deep .scrollbar-wrap::-webkit-scrollbar {
    display: none;
  }
}
.module-item-link, .recent-item {
  padding: 8px;
  color: #666;
  cursor: pointer;
  transition: all ease-in-out 0.1s;
  flex: 0 0 33.33%;
  width: 33.33%;
  .link {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .icon {
    opacity: 0;
    flex: 0 0 14px;
    font-size: 14px;
    color: var(--antd-wave-shadow-color);
    font-weight: bolder;
    transition: all ease-in-out 0.1s;
  }
  &:hover {
    background: #ebebeb;
    .icon {
      opacity: 1;
    }
  }
}
.stared {
  .icon {
    opacity: 1;
  }
}
.shadow-sm {
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
}
</style>
